import { Image, Title, Text, Group, createStyles } from '@mantine/core';
const useStyle = createStyles((theme) => ({
  title: {
    fontFamily: 'Nunito Sans, sans-serif',
    fontWeight: 700,
    fontSize: 14,
    color: '#000000',
    '@media (min-width: 600px)': {
      fontSize: 17,
    },
  },
  text: {
    fontSize: 12,
    fontWeight: 400,
    color: '#4D4D4D',
    textAlign: 'justify',
    marginTop: 10,
    marginBottom: 10,
    '@media (min-width: 600px)': {
      fontSize: 14,
    },
  },
  date: {
    fontSize: 12,
    fontWeight: 700,
    color: '#000000',
    '@media (min-width: 600px)': {
      fontSize: 13,
    },
  },
  writter: {
    fontSize: 12,
    fontWeight: 400,
    color: '#000000',
    '@media (min-width: 600px)': {
      fontSize: 13,
    },
  },
}));
const ArticleMobileCompo = () => {
  const { classes } = useStyle();
  return (
    <div className="container">
      <hr />
      <div className="row align-items-center">
        <div className="col-6">
          <Image
            src="https://images.unsplash.com/photo-1585829365295-ab7cd400c167?ixlib=rb-1.2.1&ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&auto=format&fit=crop&w=1470&q=80"
            className={classes.image}
          />
        </div>
        <div className="col">
          <Title className={classes.title}>
            Makin Untung dengan Komisi Instan dari Sepakat
          </Title>
          <Text className={classes.text}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus et
            magna eu lectus lobortis posuere ut eget turpis. Quisque sit amet
            nunc a risus rhoncus tempus. Nulla ut neque erosrisus rhoncus
            tempus. Baca lebih lanjut
          </Text>
          <Group>
            <Text className={classes.date}>18 Mei 2022</Text>
            <Text className={classes.writter}>Admin Sepakat</Text>
          </Group>
        </div>
      </div>
      <hr />
    </div>
  );
};

export default ArticleMobileCompo;
